export * from "./UrlHelper";

export async function Async(callback: () => Promise<void>) {
    try {
        await callback();
    } catch (error) {
        console.error("An error occurred:", error);
    }
}

export async function wait(ms: number = 1000) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getError(error: unknown) {
    if (error instanceof Error) {
        return error.message;
    } else if (typeof error === "string") {
        return error;
    } else {
        return `UnknownErrorType: ${JSON.stringify(error)}`;
    }
}

export function isAdmin(permissions: string[]) {
    return permissions.includes("fuzion.permissions.admin/admin");
}